// src/pages/Cleaning/Swaps/RequestCleaningSwap.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

/* =========================================================
   REQUEST CLEANING SWAP (END-TO-END)
   - User selects ONE of their own cleaning swap listings
   - Sends swap request to other user
========================================================= */

function RequestCleaningSwap() {
  const { id: targetListingId } = useParams(); // the listing being requested
  const navigate = useNavigate();

  const [myListings, setMyListings] = useState([]);
  const [selectedListingId, setSelectedListingId] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");



  /* ---------------------------------------------------------
     LOAD USER'S OWN CLEANING SWAP LISTINGS
  --------------------------------------------------------- */
  useEffect(() => {
    async function loadMyListings() {
      try {
        const token = localStorage.getItem("token");
        const user = JSON.parse(localStorage.getItem("user"));

        const res = await fetch(
          `${API_BASE_URL}/api/cleaning/swap-listings/user/${user.id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = await res.json();
        const availableOnly = (data.listings || []).filter(
  (l) => l.swap_status === "available"
);

setMyListings(availableOnly);


      } catch (err) {
        console.error("❌ Failed loading user listings", err);
        setError("Failed to load your swap listings");
      } finally {
        setLoading(false);
      }
    }

    loadMyListings();
  }, [API_BASE_URL]);

  /* ---------------------------------------------------------
     SUBMIT SWAP REQUEST
  --------------------------------------------------------- */
  const submitRequest = async () => {
    if (!selectedListingId) {
      setError("Please select one of your listings to swap");
      return;
    }

    try {
      setSubmitting(true);
      setError("");

      const token = localStorage.getItem("token");

      const res = await fetch(
        `${API_BASE_URL}/api/cleaning/swaps/request`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            targetListingId,
            offeredListingId: selectedListingId,
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Failed to send swap request");
        return;
      }

      // ✅ SUCCESS FLOW
      alert("✅ Swap request sent! The other user has been notified.");
      navigate("/dashboard");
    } catch (err) {
      console.error("❌ Swap request failed", err);
      setError("Something went wrong sending the swap request");
    } finally {
      setSubmitting(false);
    }
  };

  /* ---------------------------------------------------------
     RENDER
  --------------------------------------------------------- */
  if (loading) return <p style={{ padding: 20 }}>Loading your listings…</p>;

  return (
    <div style={container}>
      <h2>🔁 Request Cleaning Swap</h2>

      <p style={{ marginBottom: 15 }}>
        Choose <strong>one</strong> of your cleaning clients to offer in exchange.
      </p>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <select
        value={selectedListingId}
        onChange={(e) => setSelectedListingId(e.target.value)}
        style={select}
      >
        <option value="">-- Select your listing --</option>
        {myListings.map((l) => (
          <option key={l.id} value={l.id}>
            {l.listingId} — {l.swap_from_suburb} → {l.swap_to_suburb}
          </option>
        ))}
      </select>

      <button
        onClick={submitRequest}
        disabled={submitting}
        style={submitBtn}
      >
        {submitting ? "Sending Request…" : "Send Swap Request"}
      </button>

      <button
        onClick={() => navigate(-1)}
        style={cancelBtn}
      >
        Cancel
      </button>
    </div>
  );
}

/* ----------------- styles ----------------- */

const container = {
  maxWidth: 500,
  margin: "60px auto",
  background: "#fff",
  padding: 25,
  borderRadius: 12,
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const select = {
  width: "100%",
  padding: 12,
  marginBottom: 20,
  borderRadius: 8,
  border: "1px solid #ccc",
};

const submitBtn = {
  width: "100%",
  padding: 14,
  background: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontWeight: "bold",
  cursor: "pointer",
  marginBottom: 10,
};

const cancelBtn = {
  width: "100%",
  padding: 12,
  background: "#eee",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

export default RequestCleaningSwap;

